import { handleActions, createActions } from 'redux-actions';
import { Map } from 'immutable';

export const {
  updateAgentListAction,
  updateAgentListActionById,
  updateAgentGroupsAction,
  updateAgentMap,
  updataAgentChatUrl
} = createActions({
  updateAgentListAction: action => {
    return action;
  },
  updateAgentListActionById: action => {
    return action;
  },
  updateAgentGroupsAction: action => {
    return action;
  },
  updateAgentMap: action => {
    return action;
  },
  updataAgentChatUrl: action => {
    return action;
  }
});

const initState = Map({
  agentGroupsList: [],
  agentList: [],
  agentMap: {},
  agentChatUrl: ''
});

const agent = handleActions(
  {
    [updateAgentListAction]: (state, action) => {
      const data = action.payload(state.get('agentList'));
      return state.set('agentList', data);
    },
    [updateAgentMap]: (state, action) => {
      return state.set('agentMap', action.payload);
    },
    [updateAgentListActionById]: (state, action) => {
      const { id, func } = action.payload;
      const selecData = state.get('agentList').find(value => {
        return value.id === id;
      });
      const data = func(selecData);
      return state.update('agentList', agentList => {
        return agentList.map(agent => {
          if (agent.id === id) {
            return data;
          }
          return agent;
        });
      });
    },
    [updateAgentGroupsAction]: (state, action) => {
      const data = action.payload(state.get('agentGroupsList'));
      return state.set('agentGroupsList', data);
    },
    [updataAgentChatUrl]: (state, action) => {
      const data = action.payload;
      return state.set('agentChatUrl', data);
    }
  },
  initState
);

export default agent;
